import React from 'react';
import { AnnouncementBar } from '../components/layout/AnnouncementBar';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from '../components/sections/HeroSection';
import { SocialProofStats } from '../components/sections/SocialProofStats';
import { TrustStrip } from '../components/sections/TrustStrip';
import { MoneyPageSpotlight } from '../components/sections/MoneyPageSpotlight';
import { HowItWorks } from '../components/sections/HowItWorks';
import { CapabilityGrid } from '../components/sections/CapabilityGrid';
import { AboutSection } from '../components/sections/AboutSection';
import { ArtworkGuidance } from '../components/sections/ArtworkGuidance';
import { GuaranteeStrip } from '../components/sections/GuaranteeStrip';
import { FinalCTA } from '../components/sections/FinalCTA';
import { FloatingCTA } from '../components/ui/FloatingCTA';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden" data-id="element-414">
      <AnnouncementBar data-id="element-415" />
      <Header data-id="element-416" />

      <main data-id="element-417">
        <HeroSection data-id="element-418" />
        <SocialProofStats data-id="element-419" />
        <TrustStrip data-id="element-420" />
        <MoneyPageSpotlight data-id="element-421" />
        <HowItWorks data-id="element-422" />
        <CapabilityGrid data-id="element-423" />
        <AboutSection data-id="element-424" />
        <ArtworkGuidance data-id="element-425" />
        <GuaranteeStrip data-id="element-426" />
        <FinalCTA data-id="element-427" />
      </main>

      <Footer data-id="element-428" />
      <FloatingCTA data-id="element-429" />
    </div>;
}